module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.9885a714.woff";